import * as zod from 'zod';

/**
 * Shape for the `roboflowCredentials` feathers service.
 *
 * `create` carries `apiKey` — a long-lived Roboflow workspace key minted in the
 * browser via Sign In With Roboflow — plus an optional `workspaceName` for
 * display. The key is write-only and never read back to the client. `find`
 * returns `configured` + `workspaceName` so the UI can show connection status.
 * Each successful `create` overwrites the previously stored key, so switching
 * Roboflow accounts takes effect immediately.
 */
export const RoboflowCredentialsData = zod.object({
  apiKey: zod.string().optional(),
  workspaceName: zod.string().optional(),
  configured: zod.boolean().optional(),
});

export type RoboflowCredentialsData = zod.infer<typeof RoboflowCredentialsData>;
